import html2canvas from 'html2canvas'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useLocation, useNavigate } from 'react-router-dom'
import { WhatsappShareButton } from 'react-share'
import { Btn, LoaderPage } from '../components'
import { ModalBody, ModalComponent, ModalHeader } from '../components/modal/ModalComponent'
import { useAppDispatch, useAppSelector } from '../hooks/reducer/hooks'
import calculateAnswers from '../utils/calculateAnswers'
import { setAnswers } from '../redux/questionSlicer'
import { postEmail } from '../service'
import { EmailData } from '../interfaces/EmailData'
import { IBrandForm, IValidationQuestions } from '../interfaces'

export default function Result(): React.ReactElement {
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [isError, setIsError] = useState<boolean>(false)
	const [calcPorc, setCalcPorc] = useState<number>(0)
	const [openModal, setOpenModal] = useState<boolean>(false)
	const [listResults, setListResults] = useState<any>([]) //mudar para algum tipo customizado
	const navigate = useNavigate()
	const answers = useAppSelector(state => state.question.answers)
	const dispatch = useAppDispatch()
	const queryParams = new URLSearchParams(useLocation().search)

	useEffect(() => {
		const header = document.querySelector('.menu')
		if (header) {
			header.classList.remove('header--margin-left', 'header--centralize')
		}
	})

	function downloadImg(instragram = true): void {
		if (instragram) window.open('https://www.instagram.com/')
		else window.open('https://www.linkedin.com/feed/')
		// const resultRef = document.getElementById('result') as HTMLElement
		// html2canvas(resultRef).then(canvas => {
		// 	document.body.appendChild(canvas)

		// 	const image = canvas.toDataURL('image/png', 0.9)
		// 	const link = document.createElement('a')
		// 	link.download = 'meuResultado.png'
		// 	link.href = image
		// 	link.click()

		// 	if (instragram) window.open('https://www.instagram.com/')
		// 	if (!instragram) window.open('https://www.linkedin.com/feed/')

		// 	const canvasImg = document.querySelector('canvas') as HTMLElement
		// 	canvasImg.style.width = '0'
		// })
	}

	function getResults(): void {
		setIsLoading(true)
		try {
			const localAnswers = JSON.parse(localStorage.getItem('userAnswers') || '')
			let response
			if (answers.length > 0) {
				response = calculateAnswers(answers)

				localStorage.setItem('userAnswers', answers)
			} else {
				response = calculateAnswers(localAnswers)
				dispatch(setAnswers(localAnswers))
			}
			setCalcPorc((response.totalPoints / 225) * 100)
			setListResults(response.answers)

			setIsLoading(false)
		} catch (e) {
			setIsError(true)
			setTimeout(() => {
				navigate('/')
			}, 2500)
		}
	}

	function setColor(value: any): string {
		let color = ''

		if (value > 79) color = 'green'
		if (value > 49 && value < 80) color = 'yellow'
		if (value < 50) color = 'red'

		return color
	}

	useEffect(() => {
		getResults()
	}, [])
	// Pra testar sem completar o form todas vezes
	// function sendEmail(): void {
	// 	const userValuesJson = localStorage.getItem('userValues')
	// 	const userAnswersJson = localStorage.getItem('userAnswers')
	// 	if (userValuesJson && userAnswersJson) {
	// 		const userValues = JSON.parse(userValuesJson) as IBrandForm
	// 		const userAnswers = JSON.parse(userAnswersJson) as IValidationQuestions
	// 		const response = calculateAnswers(userAnswers)

	// 		const emailData: EmailData = {
	// 			userValues,
	// 			traficValues: {
	// 				traffic_source: queryParams.get('utm_source'),
	// 				traffic_medium: queryParams.get('utm_medium'),
	// 				traffic_campaign: queryParams.get('utm_campaign'),
	// 				traffic_value: queryParams.get('utm_term'),
	// 			},
	// 			userAnwsers: response.answers,
	// 			totalPoints: response.totalPoints,
	// 		}

	// 		postEmail(emailData)
	// 	}
	// }

	return (
		<>
			<Helmet>
				<title> Seu resultado Brandtech </title>
				<meta name="description" content="Seu resultado Brandtech" />
			</Helmet>
			{isError ? <LoaderPage error={isError} /> : <></>}
			{isLoading ? <LoaderPage pasDelay={isLoading} /> : <></>}
			{!isLoading && !isError && (
				<>
					<div className="container bk-result">
						<div className="result-content">
							<h1>
								Seu resultado
								<span className="brantech-text"> Brandtech </span>
							</h1>

							<div className="sociais-desktop">
								<p> Compartilhe </p>
								<div className="share">
									<button
										id="btn-share-linkedin"
										onClick={() => {
											window.dataLayer?.push({
												event: 'compartilhar_linkedin',
												social_network: 'LinkedIn',
											})
											downloadImg(false)
										}}
									>
										<img src="/assets/img/outhers/linkedin.png" alt="LinkedIn" title="LinkedIn" />
									</button>
									<WhatsappShareButton
										id="btn-share-whatsapp"
										url={window.location.href}
										title="Seu resultado Brandtech"
										separator=""
										windowHeight={2000}
										windowWidth={5000}
										onClick={() => {
											window.dataLayer?.push({
												event: 'compartilhar_whatsapp',
												social_network: 'WhatsApp',
											})
										}}
									>
										<img src="/assets/img/outhers/whats.png" alt="WhatsApp" title="WhatsApp" />
									</WhatsappShareButton>
									<button
										id="btn-share-instagram"
										className="imagem-insta"
										onClick={() => {
											window.dataLayer?.push({
												event: 'compartilhar_instagram',
												social_network: 'Instagram',
											})
											downloadImg(true)
										}}
									>
										<img src="/assets/img/outhers/instagram.png" alt="Instagram" title="Instagram" />
									</button>
								</div>
							</div>
						</div>
						<div className="results" id="result">
							<div className={`level-result ${setColor(Math.round(calcPorc).toFixed(0))}`}>
								<div className="content-result md:py-0 py-3">
									<p className="total md:mb-10 mb-4">Total:</p>

									<p className="percentual">{Math.round(calcPorc).toFixed(0)}%</p>
									<div className="progress-bar">
										<div
											className="progress"
											style={{
												width: `${calcPorc}%`,
											}}
										/>
									</div>
									<p className="txt-scoring">Seu nível de maturidade em Brand Scoring</p>
								</div>
							</div>
							<div className="brand-results">
								<div className="brand-content">
									{listResults &&
										listResults.map((item: any, index: any) => (
											<div className="box-category flex flex-row items-center" key={`box-${index}`}>
												<p
													className={`category pt-1 ${
														item.categorySum <= 12
															? 'red'
															: item.categorySum <= 20
															? 'yellow'
															: item.categorySum <= 25
															? 'green'
															: 'green'
													}`}
												>
													{item.name}
												</p>
												<div
													className={`bol h-fit flex flex-col justify-center ${
														item.categorySum <= 12
															? 'red'
															: item.categorySum <= 20
															? 'yellow'
															: item.categorySum <= 25
															? 'green'
															: 'green'
													}`}
												>
													<p
														className={`points text-center ${
															item.categorySum <= 12
																? 'red'
																: item.categorySum <= 20
																? 'yellow'
																: item.categorySum <= 25
																? 'green'
																: 'green'
														}`}
													>
														{item.categorySum}
													</p>
												</div>
											</div>
										))}
								</div>
							</div>
						</div>

						<div className="grid-point">
							<div className="content">
								<div className="bol red"> </div>
								<p> De 0 a 12 pontos na categoria</p>
							</div>
							<div className="content">
								<div className="bol yellow"> </div>
								<p> De 13 a 20 na categoria </p>
							</div>
							<div className="content">
								<div className="bol green"> </div>
								<p> De 21 a 25 na categoria</p>
							</div>
						</div>

						<div className="div-ai">
							<span>Ainda ficou com dúvidas sobre Brandtech?</span>
						</div>

						<div className="btn-action btn-ai">
							<Btn
								id="btn-plano-acao"
								placeholder="Quero um plano de ação"
								height="2.938rem"
								width="16.063rem"
								type="button"
								onClick={() => setOpenModal(true)}
							/>

							<Btn
								id="btn-chat-ia"
								placeholder="Converse com a nossa IA"
								height="2.938rem"
								width="16.063rem"
								type="button"
								onClick={() => window.open('/chat', '_blank')}
							/>
						</div>
					</div>

					<div className="container bk-scoring">
						<div className="content">
							<>
								{calcPorc / 2 >= 0 && calcPorc / 2 <= 24 ? (
									<div>
										<h2> Iniciante </h2>
										<p>
											Se você fez menos de 24 pontos é sinal que a sua empresa está no nível inicial da Brandtech. Ou seja, tem
											muita tarefa para resolver e preparar o negócio para a aplicação da metodologia. Mas não se preocupe.
											Sempre é tempo de rever o Planejamento Estratégico e incluir OKRs conectados a metodologia para preparar o
											seu negócio para o crescimento.
										</p>
									</div>
								) : calcPorc / 2 >= 25 && calcPorc / 2 <= 39 ? (
									<div>
										<h2> Intermediário </h2>
										<p>
											Se você ficou da faixa de 25 a 39 pontos, ótimo. A sua maturidade Brandtech já é perceptível e está bem
											aplicada. O recado aqui é entender os pontos de carência para desafiar os líderes da empresa ao
											aperfeiçoamento. O conselho é incluir estes pontos nos seus OKRs táticos para o trimestre ou para o ano.
										</p>
									</div>
								) : calcPorc / 2 >= 40 && calcPorc / 2 <= 100 ? (
									<div>
										<h2> Avançado </h2>
										<p>
											Acima de 40 pontos você pode considerar o seu negócio apto e alinhado a metodologia. Importante a partir
											de agora monitorar a qualidade dos seus atributos Brandtech. Mantenha o crescimento constante do
											desempenho alinhado a sua NorthStar Metric. Acompanhe a seguir o Passo a Passo enxuto da aplicação da
											Metodologia.
										</p>
									</div>
								) : (
									''
								)}
							</>
						</div>
						<img src="/assets/img/outhers/finally.png" alt="Brand Scoring" title="Brand Scoring" className="img-scoring" />
					</div>
				</>
			)}
			<ModalComponent isShowing={openModal} callBack={() => setOpenModal(false)}>
				<>
					<ModalHeader callBack={() => setOpenModal(false)} title="Maravilha" key="teste" />
					<ModalBody>
						<p className="txt-agradecimento">Nosso time de estrategistas entrará em contato em breve com você.</p>
					</ModalBody>
				</>
			</ModalComponent>
		</>
	)
}
